var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"googleMap",staticClass:"google-map"}),(Boolean(this.google) && Boolean(this.map))?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map,"bounds":_vm.bounds,"project":_vm.project})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }